import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { NgRedux } from '@ptl/angular-redux-store';
//import * as moment from 'moment';
import moment from 'moment';
import { StateStructure } from '@ptl/state';
import { LIFE_EVENT_DOCUMENT_UPLOAD_REDUCER, removeSEPLifeEventDocumentInfo, resetSEPLifeEventDocumentInfo, setSEPLifeEventDocumentInfo } from 'src/app/angular-elements/shared/components/configs/reducers/life-event.reducer';
import { AbstractControl, Validators } from '@angular/forms';
import { RequiredDocsUploadComponent } from '../required-docs-upload/required-docs-upload/required-docs-upload.component';
import { LifeEventDocumentUpload, LifeEventStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/life-event.state-structure.interface';
import { FileDisplayComponent } from '../required-docs-upload/file-display/file-display.component';
import { RequiredDocsUploadService } from '../required-docs-upload/services/required-docs-upload.service';
import { SpecialEnrollmentCircumstance } from 'src/app/angular-elements/shared/interfaces/special-enrollment-circumstances.interface';
import { RequiredDocsUploadFormComponent } from '../required-docs-upload/required-docs-upload-form.component';

/** 
 * Reflects the fact that this component doesn't KNOW the name of its
 * entry configurations ( from shopx-forms )
 */
@FormComponentLookup('special-enrollment-event-document-upload')
@Component({
    selector: 'app-special-enrollment-event-document-upload',
    templateUrl: './special-enrollment-event-document-upload.component.html',
    styleUrls: ['./special-enrollment-event-document-upload.component.scss'],
    standalone: false
})
export class SpecialEnrollmentEventDocumentUploadComponent extends RequiredDocsUploadFormComponent {

  @ViewChild('RequiredDocsUploadComponent') requiredDocsUploadComponent: RequiredDocsUploadComponent;

  effectiveDate: string;
  lifeEvent: string;
  lifeEventDate: string;
  
  /** Snatched from state and passed to children */
  existingDocs: LifeEventDocumentUpload[];

  constructor() {
    super();
    this.ngRedux = this.injector.get(NgRedux);
    this.requiredDocsUploadService = this.injector.get(RequiredDocsUploadService);
  }

  ngOnInit(): void {
    const lifeEventDocumentUploadState: LifeEventStateStructure
      = this.reducerUtilityService.getComponentStates()[LIFE_EVENT_DOCUMENT_UPLOAD_REDUCER];
      
    /** Pre-Populate Display stuff */
    if (lifeEventDocumentUploadState.documents.length > 0) {
      this.existingDocs = lifeEventDocumentUploadState.documents;
    }

    /** Effective Date stuff */
    const appStates = this.reducerUtilityService.getGlobalStateItem('appStates');
    const effectiveDateState: {
      effectiveDate: string
    } = appStates['EffectiveDate'];
    this.effectiveDate = moment(effectiveDateState.effectiveDate).format('MM/DD/YYYY').toString();

    /** SEP Event stuff */
    const payloadStates = this.reducerUtilityService.getPayloadStates();
    const specialEnrollmentState: SpecialEnrollmentCircumstance = payloadStates['special-enrollment-circumstance'];

    if (specialEnrollmentState) {
      this.lifeEventDate = specialEnrollmentState.dateOfLifeEvent ? moment(specialEnrollmentState.dateOfLifeEvent).format('MM/DD/YYYY').toString() : null;
      this.lifeEvent = specialEnrollmentState.lifeEvent.lifeEventDescription;
    }
  }

  /** Extendable */
  saveResponseToState(fileComponent: FileDisplayComponent) {
    this.ngRedux.dispatch(setSEPLifeEventDocumentInfo(fileComponent.displayableFileObj));
  }

  removeResponseFromState(fileComponent: FileDisplayComponent) {
    this.ngRedux.dispatch(removeSEPLifeEventDocumentInfo(fileComponent.displayableFileObj.documentRecord));
  }
}
